import cx from 'classnames'
import { MadkuduLabelMap } from 'app/modules/playbook/constants'

import './style.styl'

const MadKuduTag = ({ score }) => {
  const scoreToclassNameMap = {
    ['very good']: 'madkudu-tag-vg',
    ['good']: 'madkudu-tag-g',
    ['medium']: 'madkudu-tag-med',
    ['low']: 'madkudu-tag-low',
  }
  const scoreLabel = MadkuduLabelMap[score]
  return (
    <div key={score} className={cx('Tag', 'madkudu-tag', scoreToclassNameMap[score])}>
      {scoreLabel}
    </div>
  )
}

export default MadKuduTag



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MadKuduTag/index.js